<template>
  <div>
    <div class="row">
      <!--      <input type="number" v-model="step">-->
      <!--      <button @click="editingMode = !editingMode">Editmode = {{ editingMode }}</button>-->

      <div class="col-12">
        <div class="row" v-show="step == 1">
          <div class="col-12">
            <FileUpload
                @departmentChanged="department = $event"
                :departments="getCompanyDepartments"
                @fileChanged="setFile($event)"
                @changeStep="setStep($event)"
                @imageData="setSvgImage($event)"/>
          </div>

        </div>
        <SidebarRight :key=2 v-show="step === 2" :openOnCreate="true" :showCloseButton="false">
          <template v-slot:sidebar-header>
            <div @click="step = 1" class="back-button  d-flex align-items-center justify-content-start mt-3">
              <svg class="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M7 12L17 12M7 12L11 8M7 12L11 16" stroke="#2A52BE" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
              </svg>
              <span>{{ $t('ui.back') }}</span>
            </div>
          </template>
          <template v-slot:sidebar-title>
            <div class="col-12">
              <h3>{{ $t('admin.floorPlan.departmentDrawing.title') }}</h3>
            </div>
          </template>
          <template v-slot:sidebar-body>
            <div>
              <div class="col-12">
                <p style=" white-space: pre-line">{{ $t('admin.floorPlan.departmentDrawing.description') }} </p>
              </div>
              <hr class="mb-5">
              <div class="col-12">
                <label for="opacity-slider" id="opacity-slider-label" class="form-label">{{
                    $t('admin.floorPlan.departmentDrawing.opacity')
                  }}</label>
                <input type="range"
                       class="form-range form-control"
                       step="0.1"
                       max="1"
                       min="0"
                       id="opacity-slider" v-model="backgroundOpacity">
              </div>
              <div class="col-12">
                <button class="btn btn-cancel" @click="resetDrawing">{{$t('admin.floorPlan.departmentDrawing.resetDrawing')}}</button>
              </div>
            </div>

          </template>
          <template v-slot:sidebar-footer>
            <div style="  display: flex;  align-items: start;  justify-content: start;">
              <button class="btn btn-primary  btn-block  btn-primary my-3 mx-3" @click="savePolygon">{{
                  $t('admin.floorPlan.workflowPlacement.title')
                }}
              </button>
            </div>
          </template>
        </SidebarRight>
        <SidebarRight :key=3 v-show="step === 3"
                      :openOnCreate="true"
                      :showOverflowBlock="true"
                      :showCloseButton="false">
          <template v-slot:sidebar-header>
            <div class="back-button  d-flex align-items-center justify-content-between mt-3">
              <div @click="step = 2">
                <svg class="mr-2" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 12L17 12M7 12L11 8M7 12L11 16" stroke="#2A52BE" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
                <span>{{ $t('ui.back') }}</span>
              </div>
<!--              <div id="edit-mode-toggle" class="mr-3" @click="editingMode = !editingMode">-->
<!--                <i :class="editingMode ? 'fal fa-eye-slash' : 'fal fa-eye'"></i>-->
<!--              </div>-->
            </div>

          </template>
          <template v-slot:sidebar-title>
            <div class="col-12">
              <h3>{{ $t('admin.floorPlan.workflowPlacement.title') }}</h3>
            </div>
          </template>
          <template v-slot:sidebar-body>
            <div class="col-12 " style="padding-bottom: 125px;">
              <template v-for="workflow in getWorkflowsFromDepartment(department)">
                <div :key=workflow.id class=" workflow-block"
                     @click=addRectangle(workflow)
                     :class="alreadyAdded(workflow) ? ' workflow-added' :'' ">
                  <span class="activity">{{ workflow.activities.join(", ") }}</span>
                  <h3 class="name"> {{ workflow.name }}</h3>
                </div>
              </template>
            </div>
          </template>
          <template v-slot:sidebar-footer>
            <div style="  display: flex;  align-items: start;  justify-content: start;">
              <button class="btn btn-block  btn-primary my-3 mx-3"
                      @click="saveFloorPlanAction()">
                {{ $t('ui.save') }}
                {{ $t('admin.floorPlan.floorPlan') }}
              </button>
            </div>
          </template>
        </SidebarRight>

      </div>
    </div>
    <div class="row" v-show="step > 1">


      <!--      SVG CONTAINER -->
      <div id="svgContainer" class="col-9">

          <svg
              id="svg-floormap"
              :width="width"
              :height="height"
              :style="styleBasedOnStep"
              :viewBox="viewBox"
              preserveAspectRatio="xMidYMid meet"
              @mousemove="onMouseMove($event)"
              @mouseup="onMouseUp($event)"
              @mousedown="onMouseDown($event)"
              @click="onClickItem($event,{})"
          >

            <image id="floormap" :width="width" :height="height " :transform="'translate(0 ,0)'"/>
<!--            <g :transform="'translate(0 ,0)'">-->
<!--              <foreignObject-->
<!--                  :key="item.id"-->
<!--                  :width="item.width"-->
<!--                  :height="item.height"-->
<!--                  :x="item.x" :y="item.y"-->
<!--                  v-for="item in items">-->
<!--                <component :item=item :key="item.id" :is="item.componentType"/>-->
<!--              </foreignObject>-->

<!--            </g>-->
            <!--          DRAWING LINES FROM cursor-->
            <g v-if="position && drawingBorder" transform="translate(0, 0)">
              <line class="gridlines"
                    :x1="0"
                    :y1="position.y"
                    :x2="99999"
                    :y2="position.y"
                    :id="'preview-1'"

              />
              <line class="gridlines"
                    :x1="position.x"
                    :y1="0"
                    :x2="position.x"
                    :y2="999999"
                    :id="'preview-2'"


              />
              <polyline v-if=polygonData.length :points="getPolygonData(polygonData)"
                        :fill="drawingBorder ?'none'  : 'none'" stroke="black"
                        stroke-width="2px"/>

            </g>
            <g transform="translate(0, 0)">

              <polyline v-for="polygon in getEditingModeDepartments" :points="getPolygonData(polygon)"
                        :fill="drawingBorder ?'none'  : 'none'"
                        :stroke="polygonData.length ? '#ababab' :'black'"
                        :stroke-width="polygonData.length ? '1px' :'2px'"/>
            </g>

            <line
                v-if="polygonData.length && drawingBorder"
                :x1="polygonData[polygonData.length-1].x"
                :y1="polygonData[polygonData.length-1].y"
                :x2="forcedPosition.x"
                :y2="forcedPosition.y"
                :id="'preview'"
                stroke="red"
                stroke-width="2px"
            />
            <!--          <g v-for="item in borders" transform="translate(0.5,0.5)">-->
            <!--            &lt;!&ndash; item &ndash;&gt;-->
            <!--            <g>-->
            <!--              <line-->

            <!--                  :x1="item.x"-->
            <!--                  :y1="item.y"-->
            <!--                  :x2="item.x2"-->
            <!--                  :y2="item.y2"-->
            <!--                  :style="item.style"-->
            <!--                  :id="item.id"-->
            <!--                  stroke="black"-->
            <!--                  stroke-width="2px"-->
            <!--                  @cflick="onClickItem($event,item)"-->
            <!--              />-->
            <!--              &lt;!&ndash; controls-->
            <!-- <g v-for="item in items"-->
            <!--   :transform="'translate('+item.x+', '+item.y+')'"-->
            <!--   v-if="item.active"-->
            <!-- >&ndash;&gt;-->
            <!--              <g v-if="item.active">-->
            <!--                <rect-->
            <!--                    :x="0"-->
            <!--                    :y="0"-->
            <!--                    :width="item.width"-->
            <!--                    :height="item.height"-->
            <!--                    class="ctrl-bounds"-->
            <!--                    @click="onClickItem($event,item)"-->
            <!--                    @_mouseout="onMouseUpRegion($event,item)"-->
            <!--                    @mousedown="onMouseDownRegion($event,item)"-->
            <!--                />-->
            <!--                <g-->
            <!--                    @mousedown="onMouseDownHandles($event,item)"-->
            <!--                >-->
            <!--                  <rect-->
            <!--                      class="ctrl-rect"-->
            <!--                      :width="tools.squaresize"-->
            <!--                      :height="tools.squaresize"-->
            <!--                      data-handleid="1"-->
            <!--                      :x="0-tools.squaresize/2"-->
            <!--                      :y="0-tools.squaresize/2"-->
            <!--                  />-->
            <!--                  <rect-->
            <!--                      class="ctrl-rect"-->
            <!--                      :width="tools.squaresize"-->
            <!--                      :height="tools.squaresize"-->
            <!--                      data-handleid="3"-->
            <!--                      :x="item.width-tools.squaresize/2"-->
            <!--                      :y="0-tools.squaresize/2"-->
            <!--                  />-->
            <!--                  <rect-->
            <!--                      class="ctrl-rect"-->
            <!--                      :width="tools.squaresize"-->
            <!--                      :height="tools.squaresize"-->
            <!--                      data-handleid="7"-->
            <!--                      :x="0-tools.squaresize/2"-->
            <!--                      :y="item.height-tools.squaresize/2"-->
            <!--                  />-->
            <!--                  <rect-->
            <!--                      class="ctrl-rect"-->
            <!--                      :width="tools.squaresize"-->
            <!--                      :height="tools.squaresize"-->
            <!--                      data-handleid="9"-->
            <!--                      :x="item.width-tools.squaresize/2"-->
            <!--                      :y="item.height-tools.squaresize/2"-->
            <!--                  />-->
            <!--                </g>-->
            <!--              </g>-->
            <!--            </g>-->
            <!--          </g>-->
            <template v-if="editingMode">
              <g v-for="item in items" :transform="'translate('+item.x+', '+item.y+')'">
                <!-- item -->


                <g>
                  <text
                      v-if="item.type=='text'"
                      :x="getTextXPos(item)"
                      :y="item.height*0.9"
                      :width="item.width"
                      :height="item.height"
                      :font-size="item.height"
                      :font-family="item.font"
                      :fill="item.color"
                      :text-anchor="item.textAnchor"
                      @click="onClickItem($event,item)"
                  >{{ item.text }}
                  </text>
                  <rect
                      v-if="item.type=='rect'"
                      :x="0"
                      :y="0"
                      :id="item.id"
                      :width="item.width"
                      :height="item.height"
                      :fill="item.color"
                      @click="onClickItem($event,item)"
                  >
                  </rect>
                  <text v-if="item.type=='rect'" x="5" y="20" font-family="Open Sans" font-size="15" fill="#fff">
                    {{ getWorkflowName(item.id).substring(0,6) }}
                  </text>

                  <ellipse
                      v-if="item.type=='ellipse'"
                      :cx="item.width/2"
                      :cy="item.height/2"
                      :rx="item.width/2"
                      :ry="item.height/2"
                      :fill="item.color"
                      @click="onClickItem($event,item)"
                  ></ellipse>


                  <!-- controls
                  <g v-for="item in items"
                    :transform="'translate('+item.x+', '+item.y+')'"
                    v-if="item.active"
                  >-->
                  <g v-if="item.active">
                    <rect
                        :x="0"
                        :y="0"
                        :width="item.width"
                        :height="item.height"
                        class="ctrl-bounds"
                        @click="onClickItem($event,item)"
                        @_mouseout="onMouseUpRegion($event,item)"
                        @mousedown="onMouseDownRegion($event,item)"
                    />
                    <g @mousedown="onMouseDownHandles($event,item)">
                      <svg @click="removeActiveItem()" width="20" height="20" viewBox="0 0 20 20" fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                           :x="item.width-tools.squaresize/2 -8"
                           :y="0-tools.squaresize/2-2"
                      >
                        <circle cx="10" cy="10" r="9" fill="#C23E3E"/>
                        <path
                            d="M13.8636 7.19696C14.1565 6.90406 14.1565 6.42919 13.8636 6.1363C13.5708 5.8434 13.0959 5.8434 12.803 6.1363L13.8636 7.19696ZM6.13633 12.803C5.84343 13.0959 5.84343 13.5707 6.13633 13.8636C6.42922 14.1565 6.90409 14.1565 7.19699 13.8636L6.13633 12.803ZM7.19699 6.1363C6.9041 5.8434 6.42923 5.8434 6.13633 6.1363C5.84344 6.42919 5.84344 6.90406 6.13633 7.19696L7.19699 6.1363ZM12.803 13.8636C13.0959 14.1565 13.5708 14.1565 13.8637 13.8636C14.1565 13.5707 14.1565 13.0959 13.8637 12.803L12.803 13.8636ZM12.803 6.1363L6.13633 12.803L7.19699 13.8636L13.8636 7.19696L12.803 6.1363ZM6.13633 7.19696L12.803 13.8636L13.8637 12.803L7.19699 6.1363L6.13633 7.19696Z"
                            fill="white"/>
                      </svg>

                      <!--                      Commented below is the resizing feature-->


                      <!--                      <rect-->
                      <!--                          class="ctrl-rect"-->
                      <!--                          :width="tools.squaresize"-->
                      <!--                          :height="tools.squaresize"-->
                      <!--                          data-handleid="1"-->
                      <!--                          :x="0-tools.squaresize/2"-->
                      <!--                          :y="0-tools.squaresize/2"-->
                      <!--                      />-->
                      <!--                      <rect-->
                      <!--                          class="ctrl-rect"-->
                      <!--                          :width="tools.squaresize"-->
                      <!--                          :height="tools.squaresize"-->
                      <!--                          data-handleid="3"-->
                      <!--                          :x="item.width-tools.squaresize/2"-->
                      <!--                          :y="0-tools.squaresize/2"-->
                      <!--                      />-->
                      <!--                      <rect-->
                      <!--                          class="ctrl-rect"-->
                      <!--                          :width="tools.squaresize"-->
                      <!--                          :height="tools.squaresize"-->
                      <!--                          data-handleid="7"-->
                      <!--                          :x="0-tools.squaresize/2"-->
                      <!--                          :y="item.height-tools.squaresize/2"-->
                      <!--                      />-->
                      <!--                      <rect-->
                      <!--                          class="ctrl-rect"-->
                      <!--                          :width="tools.squaresize"-->
                      <!--                          :height="tools.squaresize"-->
                      <!--                          data-handleid="9"-->
                      <!--                          :x="item.width-tools.squaresize/2"-->
                      <!--                          :y="item.height-tools.squaresize/2"-->
                      <!--                      />-->
                    </g>
                  </g>
                </g>
              </g>
            </template>
          </svg>


        </div>

    </div>
  </div>
</template>

<script>
// https://codepen.io/scorch/pen/JEKorP
// https://codepen.io/gox/pen/oNgrmpK
// var photoshop = VueColor.Photoshop;
// var material = VueColor.Material;
// var sketch = VueColor.Sketch;
// var slider = VueColor.Slider;
// var compact = VueColor.Compact;
// var swatches = VueColor.Swatches;


// https://github.com/mudin/vue-svg
import {mapActions, mapGetters, mapMutations} from "vuex";

import FileUpload from "@/components/floorPlan/FileUpload";
import oee from '@/components/floorPlan/dataComponents/Oee'
import OptionsMenu from '@/components/floorPlan/OptionsMenu'
import SidebarRight from "@/components/SidebarRight";

import svgMethods from "@/mixins/floorPlan/svgMethods";

export default {
  name: "FloorPlanIndex",
  mixins: [svgMethods],
  components: {OptionsMenu, FileUpload, oee, SidebarRight},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('users', ['getMe']),
    ...mapGetters('company', ['getCompanyDepartments']),
    ...mapGetters('workflows', ['getWorkflowsGrouppedPerDepartment', 'getWorkflowsFromDepartment','getWorkflowName']),


    ...mapGetters('floorPlans', ['getFloorplan', 'getEditingModeDepartments']),
  },
  methods: {
    ...mapMutations('floorPlans', ['setDepartments', 'setWorkflows']),
    ...mapActions('floorPlans', ['saveFloorPlan', 'saveFloorPlanImage', 'getFloorPlanImage']),

    async saveFloorPlanAction() {

      this.$store.commit('setLoading',true)
      let docId = await this.saveFloorPlan(
          {
            id: this.$route.params.id,
            opacity:this.backgroundOpacity,
            workflows: this.items,
            file: this.file,
            department: this.department
          }).catch((e) => {
        console.log(e)
      });
      this.$store.commit('setLoading',false)
        this.swalToastSuccess(this.$t('ui.savedToast.success'))
        this.$router.push('/admin/floorplan')
    },

    savePolygon() {
      if (!this.getEditingModeDepartments.length) {
        this.setDepartments([this.polygonData])
        this.polygonItems.push(this.polygonData)
      }
      this.forcedPosition = {x: null, y: null}
      this.step = 3
      this.polygonData = []

    },

  },
  watch: {},
  async created() {
    this.step = 3
    let floorPlan = await this.$store.dispatch('floorPlans/fetchById', this.$route.params.id)
    // this.polygonItems = JSON.parse(floorPlan.departments)
    this.department = floorPlan.department
    this.backgroundOpacity = floorPlan.opacity
    this.setDepartments(JSON.parse(floorPlan.departments))
    this.items = JSON.parse(floorPlan.workflows)
    // this.setWorkflows(JSON.parse(floorPlan.workflows))
    let image = await this.getFloorPlanImage(this.$route.params.id)
    image = await this.autoFitSvgImage(image, 'svg-floormap')
    document.getElementById('floormap').setAttributeNS("http://www.w3.org/1999/xlink", "href", image)
    document.getElementById('floormap').style.opacity = floorPlan.opacity;
    this.$store.commit('setLoading', false)

  },

}

</script>

<style lang="scss" scoped>

$cerBlue: #2A52BE;


.btn-cancel, .btn-cancel:hover {
  border: 1.5px solid #6A7178;
  border-radius: 4px;
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
}

.btn-primary, .btn-primary:hover {
  background: $cerBlue;
  border: 0;
  border-radius: 5px;
}
#svgContainer {
  width: 100%;
  height: 100%;
  max-width: 100%;
}

#svg-floormap {
  border: 1px solid #9a9a9a;
  display: block;
  margin: 0 auto;
  cursor: auto;
  overflow: scroll;
}

.colorpicker {
  top: 100px;
  position: absolute;
}

svg text {
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

svg text::selection {
  background: none;
}

svg .ctrl-rect {
  fill: #FFFFFF;
  stroke: #222222;
  stroke-width: 1;
}

svg .ctrl-bounds {
  fill-opacity: 0;
  stroke: #222222;
  stroke-width: 1;
  stroke-linecap: round;
  stroke-dasharray: 2, 4;
}

.canvas svg {
  background: #FFF;
}

.gridlines {
  stroke: #4f4f4f;
  stroke-width: 1.5px;
}


.workflow-block {
  box-sizing: border-box;
  /* Auto layout */
  cursor: pointer;

  padding: 5px 10px 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  gap: 8px;
  width: 257px;
  height: 54px;
  background: #FFFFFF;
  border: 1.5px solid #CED4DA;
  border-radius: 8px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;

  .activity {
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    /* identical to box height, or 17px */
    letter-spacing: 0.25px;
    color: #272B30;

  }

  .name {
    //::before{
    //  content: "\a";
    //  white-space: pre;
    //}
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 140%;
    letter-spacing: 0.25px;
    color: #272B30;
  }

}

.workflow-added {
  border-color:$cerBlue;
  //opacity: 0.5
}

.back-button {
  cursor: pointer;

  svg {

  }

  span {
    color: #2A52BE;
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 140%;
  }
}

#opacity-slider-label {
  color: #000000
}

#edit-mode-toggle {
  font-size: 15px;
  font-weight: 700;
  color: $cerBlue;
}
</style>